<template>
  <th class="subsearch-toggle-area-bar" id="detailedsearch_tit_feature">
    <p class="detailedsearch_tit">
      特徴
    </p>

    <ul class="detailedsearch_list">
      <li v-for="item in featuresStore.master" :key="item.code">
        <label :for="`features_${item.code}`">
          <input type="checkbox"
                v-model="innerFeatures"
                :id="`features_${item.code}`"
                :value="item.code">
          <span>{{ item.text }}</span>
        </label>
      </li>

      <li>
        <label for="hold_as_needed">
          <input v-model="innerHoldAsNeeded" id="hold_as_needed" type="checkbox" true-value="1" false-value="" name="hold_as_needed"><span>日程応相談</span>
        </label>
      </li>
    </ul>
  </th>
</template>

<script setup>
import { computed, inject } from 'vue'

const featuresStore = inject('featuresStore')
const holdAsNeededStore = inject('holdAsNeededStore')

const innerFeatures = computed({
  get: () => featuresStore.features.value,
  set: (value) => featuresStore.set(value)
})
const innerHoldAsNeeded = computed({
  get: () => holdAsNeededStore.holdAsNeeded.value,
  set: (value) => holdAsNeededStore.set(value)
})
</script>
